import { Type } from "@sinclair/typebox";
export const PublicationSchema = Type.Object({
    id: Type.String(),
    publishedAt: Type.String({
        format: "date-time",
        description: "ISO8601 format date-time string indicating when the image was published",
        examples: ["2026-01-01T12:00:00Z"],
    }),
    title: Type.String({
        description: "Title or headline associated with the publication or usage of the image",
        examples: ["Rålekkert bond-eventyr"],
    }),
    publishingTarget: Type.String({
        description: "The platform or medium where the image was published or used",
        examples: ["NRK.no", "NRK TV"],
    }),
    url: Type.Optional(Type.String({
        format: "uri",
        description: "URL linking to the publication or usage of the image",
        pattern: "^https?://",
        examples: ["https://www.nrk.no/artikkel/ralekkert-bond-eventyr-236"],
    })),
}, { description: "Information about where image has been published or used" });
//# sourceMappingURL=publications.js.map